import { AllAvailableFilterTypes, ContainerFilter } from '../types';

export const getFilterByName = (filter: AllAvailableFilterTypes, availableFilters?: ContainerFilter[]) => {
    return availableFilters?.find((f) => f.type === filter);
};
